<template>
  <div>
    <div class="main-userinfo" v-if="showType === 'main'">
      <div class="userinfo-item">
        <span class="user-key">昵&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;称:</span>
        <input class="name-input" v-if="isShowNameInput" v-model="userName" />
        <span v-else class="user-val">{{$store.state.userInfo.nick_name}}</span>
         <a v-if="isShowNameInput" class="user-op" @click="saveNameClick">保存</a>
        <a v-else class="user-op" @click="updateNameClick">修改</a>
      </div>
      <div class="userinfo-item">
        <span class="user-key">注册手机:</span>
        <span class="user-val">{{showPhone}}</span>
        <a class="user-op" @click="updatePhoneClick">修改</a>
      </div>
      <div class="userinfo-item">
        <span class="user-key">密&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;码:</span>
        <span class="user-val">*****</span>
        <a class="user-op" @click="updatePassClick">修改</a>
      </div>
    </div>
    <div class="main-userinfo" v-if="showType === 'updatePass'">
      <update-user-pass @backClick="backClick"></update-user-pass>
    </div>
    <div class="main-userinfo" v-if="showType === 'updatePhone'">
      <update-user-phone @backClick="backClick"></update-user-phone>
    </div>
  </div>
</template>

<script>
import UpdateUserPass from '@/components/userinfo/UpdateUserPass'
import UpdateUserPhone from '@/components/userinfo/UpdateUserPhone'
import cache from '@/common/cache.js'
export default {
  name: 'UserInfo',
  components: {
    UpdateUserPass,
    UpdateUserPhone
  },
  data () {
    return {
      isShowNameInput: false,
      showType: 'main',
      userName: '',
      phone: ''
    }
  },
  mounted () {
    // "birthday": "",
    // "head_img": "",
    // "nick_name": "小江",
    // "sex": 0
    this.phone = cache.getPhone()
    this.getUserInfo()
  },
  computed: {
    showPhone: function () {
      if (!this.phone) return ''
      return this.phone.substr(0, 3) + '****' + this.phone.substr(7);
    }
  },
  methods: {
    backClick: function () {
      this.showType = 'main'
    },
    updateNameClick: function () {
      this.isShowNameInput = true
    },
    saveNameClick: function () {
      this.isShowNameInput = false
      let data = {
        nick_name: this.userName
      }
      this.$api.liveServer.updateNickName(data).then(res => {
        if (res.code === 0) {
          this.$message.success('修改成功')
          this.getUserInfo()
        }
      })
    },
    getUserInfo: function () {
      this.$api.liveServer.getUserInfo({}).then(res => {
        if (res.code === 0) {
          this.$store.state.userInfo = res.data
          this.userName = this.$store.state.userInfo.nick_name
        }
      })
    },
    updatePhoneClick: function () {
      // 更改手机
      this.showType = 'updatePhone'
    },
    updatePassClick: function () {
      this.showType = 'updatePass'
    }
  }
}
</script>

<style scoped>
  .main-userinfo{
    width: 750px;
    min-height: 750px;
    text-align: left;
  }

  .userinfo-item{
    margin-left: 50px;
    margin-top: 30px;
  }

  .user-key {
    color: #4A4A4A;
    font-size: 15px;
  }

  .user-val {
    margin-left: 15px;
    color: #4A4A4A;
    font-size: 15px;
  }

  .user-op {
    margin-left: 20px;
    color: #6FBFB9;
    font-size: 15px;
    cursor: pointer;
  }

  .name-input{
    border: 1px solid #cccccc;
    border-radius: 4px;
    padding: 5px;
    margin-left: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/page/live/UserInfo.vue